module.exports = __webpack_public_path__ + "c875aefd6e209c167dd2c52db9b0a15e.svg";